<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Solicitudes de carga')"
      icono="mdi-car-electric"
      tabla="solcarproapa"
      :campos="['id_solcarproapa-', 'id_ins', 'id_car', 'ideproapa-', 'numproapa', 'mat', 'id_estcar', 'actcar', 'descar', 'tra', 'inicar-', 'fincar-', 'kwhcar', 'coscar', 'codfacpag-', 'ultact-']"
      busqueda-rapida
      :segundos-auto-refresco="5"
      :permitir-eliminar="permisoEscritura"
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gescar");
    }
  },
};
</script>

<style>
</style>